import React from 'react';
import {
    ControlsContainer,
    HeaderComponent,
} from 'components/customer/RoomPlanner/components/Menu/Header';
import Room from 'components/customer/Room/Room';
import styled from 'styled-components';

export const Materials = () => {
    return (
        <div>
            <HeaderComponent>
                <ControlsContainer>
                    <Header>Current material & door options </Header>
                </ControlsContainer>
            </HeaderComponent>

            <br />
            <Room tabIndex={2} isMiniEditor={true} showTabNavs={[2, 3]} />
        </div>
    );
};

const Header = styled.div`
    color: ${({theme}) => theme.colors.primary.main};
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: 10px;
    margin-left: 4px;
`;
